import { clsx } from 'clsx';
import QRCode from 'qrcode.react';
import * as React from 'react';
import { Component } from 'react';

import { breakLongJobTitle } from '../../../../utils/QRCodeUtils';

import * as styles from '../QRCodePage.css';

class QRCodepage extends Component<{
  qrCodeValue: string;
  jobTitle: string;
  qrCodeId: string;
  jobPostedDate: string;
}> {
  render() {
    const {
      StyledComponentWrapper,
      StyledPrimaryHeading,
      StyledJobTitleHeading,
      StyledSecondaryHeading,
      StyledQRCode,
      StyledHeading,
      StyledJobPostedDate,
      StyledLogoBanner,
      StyledSectionWrapper,
      StyledLogo,
    } = styles;
    const { qrCodeValue, qrCodeId, jobTitle, jobPostedDate } = this.props;
    const { firstPartTitle, secondPartTitle } = breakLongJobTitle(jobTitle);
    const primaryHeadingClass = clsx(
      {
        [StyledHeading]: Boolean(secondPartTitle),
      },
      StyledJobTitleHeading,
    );
    return (
      <div className={StyledComponentWrapper}>
        <div className={StyledSectionWrapper}>
          <h1 className={StyledPrimaryHeading}>We’re hiring:</h1>
          <h1 className={primaryHeadingClass}>{firstPartTitle}</h1>
          {Boolean(secondPartTitle) && (
            <h1 className={StyledJobTitleHeading}>{secondPartTitle}</h1>
          )}
          <h2 className={StyledSecondaryHeading}>
            Scan the code to apply on SEEK
          </h2>
          <div className={StyledQRCode}>
            <QRCode id={qrCodeId} value={qrCodeValue} size={256} />
          </div>
          <h4 className={StyledJobPostedDate}>
            This job ad was posted on {jobPostedDate}
          </h4>
        </div>
        <div className={StyledLogoBanner}>
          <div className={StyledLogo} />
        </div>
      </div>
    );
  }
}

export default QRCodepage;
